import React, { useMemo } from 'react'
import MultiPicklist, { MultiPicklistOption } from './MultiPicklist'
import { AccessRuleMethod } from './model'
import { HTTP_METHODS } from './constant'
import withFormContext, {
  PropsWithFormContext,
} from 'core/components/validatedForm/withFormContext'

interface Props {
  id?: string
  label?: string
  className?: string
  value?: AccessRuleMethod[]
  onChange?: (values: AccessRuleMethod[]) => void
  required?: boolean
  error?: string
  errorMessage?: string
  disabled?: boolean
}

function MethodsMultiPicklistBase({
  id,
  label = 'Methods',
  className,
  value = [],
  onChange,
  required,
  error,
  errorMessage,
  disabled = false,
}: Props) {
  // Convert HTTP_METHODS array to dropdown options
  const methodOptions: MultiPicklistOption<AccessRuleMethod>[] = useMemo(
    () => HTTP_METHODS.map((method) => ({ label: method, value: method })),
    [],
  )

  // Use errorMessage from form context if available, otherwise use error prop
  const displayError = errorMessage || error

  return (
    <MultiPicklist<AccessRuleMethod>
      id={id}
      label={label && required ? `${label} *` : label}
      className={className}
      value={value}
      onChange={onChange}
      options={methodOptions}
      error={displayError}
      disabled={disabled}
      placeholder="Select Methods"
    />
  )
}

// Non-validated version for standalone use
export function MethodsMultiPicklist(props: Props) {
  return <MethodsMultiPicklistBase {...props} />
}

// Validated version wrapped with form context
export default withFormContext(MethodsMultiPicklistBase) as React.FC<
  PropsWithFormContext<AccessRuleMethod[], Props>
>
